import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import LegendTypeSwitch from './LegendTypeSwitch'
import LegendBlock from './LegendBlock'
import LegendOpenTracksInfo from './legendTracksInfo/LegendOpenTracksInfo'
import LegendClosedTracksInfo from './legendTracksInfo/LegendClosedTracksInfo'
import LegendLiftsInfo from './legendTracksInfo/LegendLiftsInfo'
import LegendServiceRow from './LegendServiceRow'
import { TRACK_STATE_DIFFICULTY, TRACK_STATE_STATUS } from '../../../config/constants'
import { t } from '../../../lang/trans'
import PopupCloseButtonMobile from '../../popup/PopupCloseButtonMobile'
import { separateLiftsByTypeWithCounts } from '../../../helpers/map'
import { legendServicesArray, legendTrackTypes } from '../../../helpers/legend';

class Legend extends Component {
	state = {
		blockOpenTracksIsOpen: false,
		blockClosedTracksIsOpen: false,
		block6LiftsIsOpen: false,
		block4LiftsIsOpen: false,
		block3LiftsIsOpen: false,
		block2LiftsIsOpen: false,
		blockBugilLiftsIsOpen: false,
		scrollTop: 0,
		stateRevision: 0,
	};

	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return (
			this.props.tracksState !== nextProps.tracksState ||
			this.state.stateRevision !== nextState.stateRevision ||
			this.state.scrollTop !== nextState.scrollTop
		)
	}

	toggleServiceItem = key => {
		this.setState(prevState => ({
			stateRevision: prevState.stateRevision + 1,
		}));

		this.props.onChangeMarkersVisibility(key)
	};

	toggleBlockVisibility = key => {
		this.setState(prevState => ({
			[key]: !prevState[key],
			stateRevision: prevState.stateRevision + 1,
		}))
	};

	componentWillLeave(callback) {
		setTimeout(() => {
			callback()
		}, 500)
	}

	getTitleBlockClassName = () => {
		return classNames('legend-mobile-top-title-block', {
			'legend-mobile-top-title-block--scrolled': this.state.scrollTop >= 16,
		});
	};

	getLegendClassName = () => {
		return classNames('legend__inner', {
			'legend__inner--scrolled': this.state.scrollTop >= 16,
		});
	};

	render() {

		const {
			blockBugilLiftsIsOpen,
			blockOpenTracksIsOpen,
			blockClosedTracksIsOpen,
		} = this.state;

		const {
			tracksState,
			onChangeTrackState,
			waitingTracksData,
			tracksData,
			liftsData,
		} = this.props;

		const liftsDataPrepared = separateLiftsByTypeWithCounts(liftsData);

		return (
			<div className="legend">
				<div className={this.getTitleBlockClassName()}>{t('статус витягів і трас')}</div>

				<div
					className={this.getLegendClassName()}
					onScroll={e => {
						this.setState({ scrollTop: e.target.scrollTop })
					}}
				>
					<div className="legend__inner-content">
						<LegendTypeSwitch
							activeState={tracksState}
							onChangeState={newState => onChangeTrackState(newState)}
						/>

						{tracksState === TRACK_STATE_STATUS && (
							<LegendBlock title={t('статус трас')}>
								<LegendOpenTracksInfo
									tracks={tracksData}
									onClickOnTrack={trackId => this.props.onClickOnTrack(trackId)}
									isOpen={blockOpenTracksIsOpen}
									onToggle={() => this.toggleBlockVisibility('blockOpenTracksIsOpen')}
								/>

								{waitingTracksData && waitingTracksData.length ? (
									<LegendClosedTracksInfo
										tracks={waitingTracksData}
										isWaiting
										isOpen={blockClosedTracksIsOpen}
										onClickOnTrack={trackId => this.props.onClickOnTrack(trackId)}
										onToggle={() =>
											this.toggleBlockVisibility('blockClosedTracksIsOpen')
										}
									/>
								) : null}

								{/*<LegendClosedTracksInfo*/}
								{/*	tracks={waitingTracksData}*/}
								{/*	isOpen={blockClosedTracksIsOpen}*/}
								{/*	onClickOnTrack={trackId => this.props.onClickOnTrack(trackId)}*/}
								{/*	onToggle={() =>*/}
								{/*		this.toggleBlockVisibility('blockClosedTracksIsOpen')*/}
								{/*	}*/}
								{/*/>*/}
									</LegendBlock>
									)}

								{tracksState === TRACK_STATE_DIFFICULTY && (
									<LegendBlock title={t('типи трас')}>
										{legendTrackTypes.map(trackTypeRow => (
											<LegendServiceRow
												key={trackTypeRow.title}
												title={t(trackTypeRow.title)}
												iconComponent={trackTypeRow.icon}
											/>
										))}
									</LegendBlock>
								)}

								{tracksState === TRACK_STATE_STATUS && (
									<LegendBlock title={t('статус витягів')}>
										{[6, 4, 3, 2].map(liftSeatsCount => (
											<LegendLiftsInfo
												isOpen={this.state[`block${liftSeatsCount}LiftsIsOpen`]}
												count={liftSeatsCount}
												lifts={liftsDataPrepared[`${liftSeatsCount}SEAT`]}
												liftsCount={liftsDataPrepared.counts[`${liftSeatsCount}SEAT`]}
												onToggle={() => this.toggleBlockVisibility(`block${liftSeatsCount}LiftsIsOpen`)}
												onClickOnLift={liftId => this.props.onClickOnLift(liftId)}
											/>
										))}

										<LegendLiftsInfo
											isOpen={blockBugilLiftsIsOpen}
											isBugil
											lifts={liftsDataPrepared['BUGIL']}
											liftsCount={liftsDataPrepared.counts['BUGIL']}
											onToggle={() =>
												this.toggleBlockVisibility('blockBugilLiftsIsOpen')
											}
											onClickOnLift={liftId => this.props.onClickOnLift(liftId)}
										/>
									</LegendBlock>
								)}

								<LegendBlock title={t('сервіси курорту')}>
									<div>
										{legendServicesArray.map(service => (
											<LegendServiceRow
												key={service.key}
												title={t(service.title)}
												onClick={() => this.toggleServiceItem(service.key)}
												iconComponent={service.iconComponent}
												isActive={this.props.markersVisibility[service.key]}
											/>
										))}
									</div>
								</LegendBlock>
							</div>
							</div>

							<PopupCloseButtonMobile onClick={() => this.props.onClose()}/>
							</div>
							)
						}
						}

						Legend.propTypes = {
						tracksData: PropTypes.object.isRequired,
						liftsData: PropTypes.object.isRequired,
						waitingTracksData: PropTypes.array.isRequired,
						tracksState: PropTypes.string.isRequired,
						onChangeTrackState: PropTypes.func,
						onChangeMarkersVisibility: PropTypes.func,
						markersVisibility: PropTypes.object,
						onClickOnTrack: PropTypes.func,
						onClickOnLift: PropTypes.func,
					};

						export default Legend
